'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { locationsSelectors } from '@/state/domains/locations';

import Link from '@/views/common/Link';

export default connect(
	(state, props) => ({
		location: locationsSelectors.getPageLocation(state, props),
		isMobile: appSelectors.isMobile(state, props),
	}),
	{
	}
)(
	({ username, date, location, isMobile }) => (
		<Link
			to={{
				pathname: `/user/${ username }/${ date }/route`,
				state: {
					pinpoint: location ? location._id : '',
					mapView: true,
					listView: !isMobile,
				},
			}}
		>
			<FontAwesomeIcon icon='map-marker-alt' color='#444'/>
		</Link>
	)
);
